import { c as e } from "react/compiler-runtime";
import { BrowserAuthError as t, BrowserAuthErrorCodes as n, InteractionRequiredAuthError as r, InteractionStatus as i, InteractionType as a, LogLevel as o, createStandardPublicClientApplication as s } from "@azure/msal-browser";
import { MsalAuthenticationTemplate as c, MsalProvider as l, useMsal as u } from "@azure/msal-react";
import { createContext as d, useContext as f, useEffect as p, useState as m } from "react";
import { jsx as h, jsxs as g } from "react/jsx-runtime";
import _ from "axios";
//#region src/config/Config.ts
var v = {
	Local: "local",
	Dev: "dev",
	Stg: "stg",
	Prd: "prd"
}, y = (e) => {
	let t = new URL(e).hostname;
	return t === "localhost" || t === "127.0.0.1" ? v.Local : t.startsWith("dev.") ? v.Dev : t.startsWith("stg.") ? v.Stg : v.Prd;
}, b = (e) => e !== v.Prd, x = d({
	getAuthToken: async () => {
		throw Error("getAuthToken not initialized");
	},
	logout: async () => {
		throw Error("logout not initialized");
	},
	userAccount: {}
}), S = {
	alignContent: "center",
	boxSizing: "border-box",
	display: "grid",
	gap: "1rem",
	justifyItems: "center",
	minHeight: "100vh",
	padding: "2rem",
	textAlign: "center"
}, C = (e, t) => {
	let n = t, r = "unknown_error";
	typeof n?.errorCode == "string" ? r = n.errorCode : t instanceof Error && (r = t.name), console.error(e, {
		errorCode: r,
		subError: typeof n?.subError == "string" ? n.subError : void 0,
		correlationId: typeof n?.correlationId == "string" ? n.correlationId : void 0
	});
}, w = () => {
	let t = e(1), n;
	return t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ h("div", {
		role: "status",
		"aria-live": "polite",
		style: S,
		children: "Signing in..."
	}), t[0] = n) : n = t[0], n;
}, T = () => {
	let t = e(1), n;
	return t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ h("div", {
		role: "status",
		"aria-live": "polite",
		style: S,
		children: "Logging out..."
	}), t[0] = n) : n = t[0], n;
}, E = () => {
	let t = e(1), n;
	return t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("div", {
		role: "alert",
		style: S,
		children: [/* @__PURE__ */ h("p", { children: "Unable to sign in" }), /* @__PURE__ */ h("button", {
			type: "button",
			onClick: O,
			children: "Try again"
		})]
	}), t[0] = n) : n = t[0], n;
}, D = ({ onRetry: e, onSignInAgain: t }) => {
	let [n, r] = m(), [i, a] = m(!1), o = async (e, t) => {
		r(e), a(!1);
		try {
			await t();
		} catch (e) {
			C("Authentication recovery failed", e), a(!0);
		} finally {
			r(void 0);
		}
	};
	return /* @__PURE__ */ g("div", {
		role: "alert",
		"aria-busy": n !== void 0,
		style: S,
		children: [
			/* @__PURE__ */ h("p", { children: "Unable to sign in" }),
			e && /* @__PURE__ */ h("button", {
				type: "button",
				disabled: n !== void 0,
				onClick: () => void o("retry", e),
				children: n === "retry" ? "Trying again..." : "Try again"
			}),
			/* @__PURE__ */ h("button", {
				type: "button",
				disabled: n !== void 0,
				onClick: () => void o("signIn", t),
				children: n === "signIn" ? "Signing in..." : "Sign in again"
			}),
			i && /* @__PURE__ */ h("p", {
				role: "status",
				children: "Sign-in could not be restarted. Please try again."
			})
		]
	});
};
function O() {
	return window.location.reload();
}
//#endregion
//#region src/msal/GetMsalAuthToken.ts
var k = (e, a, o) => {
	let s, c = i.None;
	return {
		getAuthToken: async () => {
			let l = {
				scopes: o,
				account: e
			};
			try {
				try {
					return (await a.acquireTokenSilent(l)).accessToken;
				} catch (e) {
					if (!(e instanceof t) || e.errorCode !== n.timedOut) throw e;
					return (await a.acquireTokenSilent(l)).accessToken;
				}
			} catch (e) {
				throw e instanceof r ? (!s && c === i.None && (s = a.acquireTokenRedirect(l).finally(() => {
					s = void 0;
				})), s && await s, e) : e;
			}
		},
		setInteractionStatus: (e) => {
			c = e;
		}
	};
}, A = "https://login.microsoftonline.com/common/oauth2/v2.0/logout", j = (t) => {
	let n = e(25), { account: r, children: i, inProgress: a, instance: o, scopes: s } = t, c;
	n[0] !== r || n[1] !== o || n[2] !== s ? (c = k(r, o, s), n[0] = r, n[1] = o, n[2] = s, n[3] = c) : c = n[3];
	let l = c;
	l.setInteractionStatus(a);
	let u = l.getAuthToken, d;
	n[4] !== r || n[5] !== o ? (d = () => o.logoutRedirect({
		account: r,
		postLogoutRedirectUri: A
	}), n[4] = r, n[5] = o, n[6] = d) : d = n[6];
	let f = d, p = r.idTokenClaims, m = p?.given_name, g = p?.family_name, _ = `${p?.given_name} ${p?.family_name}`, v = p?.user, y = p?.userType, b = p?.agent, S = p?.agency, C = p?.roles, w = p?.accessScopes, T = p?.permissions, E;
	n[7] !== C || n[8] !== w || n[9] !== T || n[10] !== m || n[11] !== g || n[12] !== _ || n[13] !== v || n[14] !== y || n[15] !== b || n[16] !== S ? (E = {
		firstName: m,
		lastName: g,
		fullName: _,
		user: v,
		userType: y,
		agent: b,
		agency: S,
		roles: C,
		accessScopes: w,
		permissions: T
	}, n[7] = C, n[8] = w, n[9] = T, n[10] = m, n[11] = g, n[12] = _, n[13] = v, n[14] = y, n[15] = b, n[16] = S, n[17] = E) : E = n[17];
	let D = E, O;
	n[18] !== u || n[19] !== f || n[20] !== D ? (O = {
		getAuthToken: u,
		logout: f,
		userAccount: D
	}, n[18] = u, n[19] = f, n[20] = D, n[21] = O) : O = n[21];
	let j = O, M;
	return n[22] !== j || n[23] !== i ? (M = /* @__PURE__ */ h(x.Provider, {
		value: j,
		children: i
	}), n[22] = j, n[23] = i, n[24] = M) : M = n[24], M;
}, M = (t) => {
	let n = e(33), { children: r, scopes: i } = t, { accounts: a, inProgress: o, instance: s } = u(), c;
	n[0] === s ? c = n[1] : (c = s.getActiveAccount(), n[0] = s, n[1] = c);
	let l = c, d;
	if (n[2] !== a || n[3] !== l) {
		if (l) {
			let e;
			n[5] === l ? e = n[6] : (e = (e) => e.homeAccountId === l.homeAccountId && e.localAccountId === l.localAccountId && e.username === l.username, n[5] = l, n[6] = e), d = a.find(e);
		} else a.length === 1 && (d = a[0]);
		n[2] = a, n[3] = l, n[4] = d;
	} else d = n[4];
	let f;
	n[7] !== a[0] || n[8] !== a.length || n[9] !== l || n[10] !== s ? (f = () => {
		!l && a.length === 1 && s.setActiveAccount(a[0]);
	}, n[7] = a[0], n[8] = a.length, n[9] = l, n[10] = s, n[11] = f) : f = n[11];
	let m;
	n[12] !== a || n[13] !== l || n[14] !== s ? (m = [
		a,
		l,
		s
	], n[12] = a, n[13] = l, n[14] = s, n[15] = m) : m = n[15], p(f, m);
	let g;
	n[16] !== d || n[17] !== a.length ? (g = () => {
		!d && a.length > 1 && console.error("Authentication account selection failed", {
			errorCode: "multiple_cached_accounts",
			subError: "active_account_missing",
			correlationId: void 0
		});
	}, n[16] = d, n[17] = a.length, n[18] = g) : g = n[18];
	let _;
	n[19] !== d || n[20] !== a.length ? (_ = [d, a.length], n[19] = d, n[20] = a.length, n[21] = _) : _ = n[21], p(g, _);
	let v;
	n[22] !== s || n[23] !== i ? (v = async () => {
		await s.clearCache(), await s.loginRedirect({
			scopes: i,
			prompt: "login"
		});
	}, n[22] = s, n[23] = i, n[24] = v) : v = n[24];
	let y = v;
	if (!d) {
		let e;
		return n[25] === y ? e = n[26] : (e = /* @__PURE__ */ h(D, { onSignInAgain: y }), n[25] = y, n[26] = e), e;
	}
	let b;
	return n[27] !== d || n[28] !== r || n[29] !== o || n[30] !== s || n[31] !== i ? (b = /* @__PURE__ */ h(j, {
		account: d,
		inProgress: o,
		instance: s,
		scopes: i,
		children: r
	}), n[27] = d, n[28] = r, n[29] = o, n[30] = s, n[31] = i, n[32] = b) : b = n[32], b;
}, N = d(void 0), P = (t) => {
	let n = e(2), { inProgress: r } = t, a;
	return n[0] === r ? a = n[1] : (a = r === i.Logout ? /* @__PURE__ */ h(T, {}) : /* @__PURE__ */ h(w, {}), n[0] = r, n[1] = a), a;
}, F = () => {
	let e = f(N);
	if (!e) throw Error("Authentication request is not initialized");
	return e;
}, I = (t) => {
	let n = e(14), { acquireToken: r, error: i, login: o } = t, { accounts: s, instance: c } = u(), l = F(), d, f;
	n[0] === i ? (d = n[1], f = n[2]) : (d = () => {
		C("Authentication failed", i);
	}, f = [i], n[0] = i, n[1] = d, n[2] = f), p(d, f);
	let m;
	n[3] !== s.length || n[4] !== r || n[5] !== o ? (m = async () => {
		s.length > 0 ? await r(a.Redirect) : await o(a.Redirect);
	}, n[3] = s.length, n[4] = r, n[5] = o, n[6] = m) : m = n[6];
	let g = m, _;
	n[7] !== l || n[8] !== c || n[9] !== o ? (_ = async () => {
		await c.clearCache(), await o(a.Redirect, {
			...l,
			prompt: "login"
		});
	}, n[7] = l, n[8] = c, n[9] = o, n[10] = _) : _ = n[10];
	let v = _, y;
	return n[11] !== g || n[12] !== v ? (y = /* @__PURE__ */ h(D, {
		onRetry: g,
		onSignInAgain: v
	}), n[11] = g, n[12] = v, n[13] = y) : y = n[13], y;
}, L = ({ authClientId: e, authInstance: t, authDomain: n, authSignupSigninPolicyId: r, envSigninPrefix: i, authEnableLogs: a }) => {
	if (!e) throw Error("authClientId is not set");
	if (!t) throw Error("authInstance is not set");
	if (!n) throw Error("authDomain is not set");
	if (!r) throw Error("authSignupSigninPolicyId is not set");
	if (!i) throw Error("envSigninPrefix is not set");
	let s;
	try {
		s = new URL(i);
	} catch {
		throw Error("envSigninPrefix must be an absolute URL ending in /redirect.html");
	}
	if (!s.pathname.endsWith("/redirect.html") || s.search !== "" || s.hash !== "") throw Error("envSigninPrefix must be an absolute URL ending in /redirect.html");
	let c = a === "true";
	return {
		auth: {
			clientId: e,
			authority: `https://${t}/${n}/${r}`,
			knownAuthorities: [t],
			redirectUri: s.href
		},
		cache: { cacheLocation: "localStorage" },
		system: { loggerOptions: { loggerCallback: (e, t, n) => {
			if (c && !n) switch (e) {
				case o.Error:
					console.error(t);
					return;
				case o.Info:
					console.info(t);
					return;
				case o.Verbose:
					console.debug(t);
					return;
				case o.Warning:
					console.warn(t);
					return;
				default: return;
			}
		} } }
	};
}, R = ({ userIdClaim: e, userTypeClaim: t, agencyClaim: n, rolesClaim: r, accessScopesClaim: i, permissionsClaim: a }) => ({
	firstName: "Local",
	lastName: "User",
	fullName: "Local User",
	user: e,
	userType: t,
	agent: e,
	agency: n,
	roles: r?.split(",").map((e) => e.trim()).filter(Boolean),
	accessScopes: i?.split(",").map((e) => e.trim()).filter(Boolean),
	permissions: a?.split(",").map((e) => e.trim()).filter(Boolean)
}), z = (t) => {
	let n = e(7), { children: r, apiConfig: i } = t, a = H, o = U, s;
	n[0] === i ? s = n[1] : (s = R(i), n[0] = i, n[1] = s);
	let c = s, l;
	n[2] === c ? l = n[3] : (l = {
		getAuthToken: a,
		logout: o,
		userAccount: c
	}, n[2] = c, n[3] = l);
	let u = l, d;
	return n[4] !== u || n[5] !== r ? (d = /* @__PURE__ */ h(x.Provider, {
		value: u,
		children: r
	}), n[4] = u, n[5] = r, n[6] = d) : d = n[6], d;
}, B = ({ children: e, apiConfig: t }) => {
	let [n, r] = m(), [i, o] = m(!1);
	return p(() => {
		let e = (e) => {
			C("Failed to initialize authentication", e), o(!0);
		};
		try {
			if (!t.authAppUri) throw Error("authAppUri is not set");
			let n = { scopes: [`${t.authAppUri}/openid`] };
			s(L(t)).then((e) => r({
				instance: e,
				authenticationRequest: n
			}), e);
		} catch (t) {
			e(t);
		}
	}, [t]), i ? /* @__PURE__ */ h(E, {}) : n ? /* @__PURE__ */ h(l, {
		instance: n.instance,
		children: /* @__PURE__ */ h(N.Provider, {
			value: n.authenticationRequest,
			children: /* @__PURE__ */ h(c, {
				interactionType: a.Redirect,
				authenticationRequest: n.authenticationRequest,
				loadingComponent: P,
				errorComponent: I,
				children: /* @__PURE__ */ h(M, {
					scopes: n.authenticationRequest.scopes,
					children: e
				})
			})
		})
	}) : /* @__PURE__ */ h(w, {});
}, V = (t) => {
	let n = e(6), { children: r, apiConfig: i } = t;
	if (i.devMode && i.userIdClaim && i.userTypeClaim) {
		let e;
		return n[0] !== i || n[1] !== r ? (e = /* @__PURE__ */ h(z, {
			apiConfig: i,
			children: r
		}), n[0] = i, n[1] = r, n[2] = e) : e = n[2], e;
	}
	let a;
	return n[3] !== i || n[4] !== r ? (a = /* @__PURE__ */ h(B, {
		apiConfig: i,
		children: r
	}), n[3] = i, n[4] = r, n[5] = a) : a = n[5], a;
};
async function H() {
	return "local-dev-auth";
}
async function U() {}
//#endregion
//#region src/api/MaintenanceMode.ts
var W = "maintenance-mode-until", G = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/, K = "/", q = (e) => {
	let t = e.headers?.[W];
	if (t === void 0) return;
	if (typeof t != "string" || !G.test(t)) throw Error(`${W} must be a UTC timestamp in YYYY-MM-DDTHH:mm:ssZ format`);
	let n = Date.parse(t);
	if (Number.isNaN(n) || new Date(n).toISOString().replace(".000Z", "Z") !== t) throw Error(`${W} must be a valid UTC timestamp in YYYY-MM-DDTHH:mm:ssZ format`);
	return t;
}, J = (e) => {
	let t = q(e);
	if (!t) return !1;
	let n = new URL(`${K}maintenance.html`, globalThis.location.origin);
	return n.searchParams.set(W, t), globalThis.location.replace(`${n.pathname}${n.search}`), !0;
}, Y = () => new Promise(() => void 0), X = (e, t = "/") => (K = t, e.interceptors.response.use((e) => J(e) ? Y() : Promise.resolve(e), (e) => _.isAxiosError(e) && e.response && J(e.response) ? Y() : Promise.reject(e))), Z = ({ userIdClaim: e, userTypeClaim: t, agencyClaim: n, rolesClaim: r, accessScopesClaim: i, permissionsClaim: a }) => {
	let o = {};
	return e !== void 0 && (o["x-claim-userId"] = e), t !== void 0 && (o["x-claim-userType"] = t), n !== void 0 && (o["x-claim-agency"] = n), r !== void 0 && (o["x-claim-roles"] = r), i !== void 0 && (o["x-claim-accessScopes"] = i), a !== void 0 && (o["x-claim-permissions"] = a), o;
}, Q = class {
	getAuthTokenFunction = void 0;
	devHeaders = {};
	constructor() {}
	transformOptions = async (e) => {
		if (!this.getAuthTokenFunction) throw Error("No getAuthTokenFunction has been provided");
		let t = await this.getAuthTokenFunction();
		return e.headers = {
			...e.headers,
			...this.devHeaders,
			Authorization: `Bearer ${t}`
		}, Promise.resolve(e);
	};
	setAuthConfig = (e, t) => {
		this.getAuthTokenFunction = e, this.devHeaders = Z(t);
	};
	async transformResult(e, t, n) {
		if (J(t)) return await new Promise(() => void 0);
		let r = String(t.headers?.["content-type"] ?? "").toLowerCase(), i = t.data;
		return t.status >= 200 && t.status < 300 && r.includes("application/json") && typeof i == "object" && i ? i : await Promise.resolve(n(t));
	}
}, $ = /* @__PURE__ */ function(e) {
	return e.Director = "director", e.SalesAgent = "salesagent", e.Admin = "admin", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.BusinessManager = "businessmanager", e.AdminManager = "adminmanager", e.MarketingExpert = "marketingexpert", e.ListingsContributor = "listingscontributor", e.LaunchContributor = "launchcontributor", e.ContractsContributor = "contractscontributor", e.TransactionsContributor = "transactionscontributor", e.FinanceContributor = "financecontributor", e.WorkflowContributor = "workflowcontributor", e.Executive = "executive", e.SuperAdmin = "superadmin", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.Agency = "agency", e.Organisation = "organisation", e.Platform = "platform", e;
}({});
//#endregion
export { te as AccessScope, $ as AgentRole, V as AgxAuth, v as AgxEnvironments, x as AuthContext, Q as AuthorizedApiBase, W as MAINTENANCE_MODE_UNTIL_HEADER, ee as StaffRole, b as isNonProductionEnvironment, J as redirectToMaintenancePage, X as registerMaintenanceModeInterceptor, y as resolveAgxEnvironment };

//# sourceMappingURL=index.js.map